export const IconSize = {
  alert: 24,
  badge: 16,
  btnSm: 16,
  btnXs: 14,
  btn: 20,
  btnCaret: 16,
  cardFigure: 32,
  cardTitle: 24,
  collapseTitle: 24,
  dropdownItem: 16,
  listItemIcon: 24,
  listItemFigure: 32,
  statsFigure: 32,
  tab: 20,
  tooltipLg: 20,
  tooltip: 16,
  h1: 32,
};
